import { ArrowBackIcon } from '../../assets/icons';
import { useNavigate } from 'react-router-dom'

const BackButton = ({link}: {link?: string}) => {
  const navigate = useNavigate();
  return (
    <button onClick={() => link ? navigate(link) : navigate(-1)} className='bg-[#F2F3F4] rounded-full flex items-center gap-1 px-3 py-[6px]'>
      <ArrowBackIcon />
      <span>Back</span>
    </button>
  )
}

export default BackButton